






















































































































































import Vue from "vue";

//Components
import DateTimeRangePicker from "@/components/DateTimeRangePicker.vue";
import DeviceTree from "@/components/DeviceTree/index.vue";

//Model
import { CReqExecutionResultEnum, CReqExecutionResultEnumToString } from "@/model/communication/CReqExecutionResultEnum";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";
import { GetI18nStringFromUserEventType, UserEventTypeEnum } from "@/model/data/enums/UserEventTypeEnum";

export default Vue.extend({
    components: {
        DateTimeRangePicker,
        DeviceTree,
    },
    props: {
        value: {},
        availableUsernames: Array as () => Array<string>,
    },
    data() {
        return { searchInput: "", searchInputUser: "", deviceTreeSelectedObjectItems: [], rerender: 0, ignoreSelectedInstallationNames: false, searchInputInvolvedUser: "" };
    },
    computed: {
        filter: {
            get: function () {
                let res;
                if (this.value) res = this.value;
                else res = [];
                return res;
            },
            set: function (newValue) {
                if (newValue) {
                    this.$emit("input", newValue);
                } else {
                    this.$emit("input", null);
                }
            },
        },
        availableUserEventTypes() {
            return Object.keys(UserEventTypeEnum)
                .filter((key) => !isNaN(Number(UserEventTypeEnum[key])))
                .sort((a, b) => a.localeCompare(b))
                .map((c) => {
                    return {
                        value: UserEventTypeEnum[c],
                        text: this.$t(GetI18nStringFromUserEventType(UserEventTypeEnum[c])),
                    };
                });
        },

        availableResponseTypes() {
            let responseTypes = Object.keys(CReqExecutionResultEnum)
                .sort((a, b) => a.localeCompare(b))
                .map((c) => {
                    let text = this.$t(CReqExecutionResultEnumToString(CReqExecutionResultEnum[c]));
                    if (c == CReqExecutionResultEnum.InvalidRequest) text += ` / ${this.$t("user_events.WrongCredentials")}`;
                    else if (c == CReqExecutionResultEnum.ServerError) text += ` / ${this.$t("user_events.MFARequired")}`;
                    else if (c == CReqExecutionResultEnum.LicenseExpired) text += ` / ${this.$t("user_events.LicenseExpired")}`;
                    return {
                        value: CReqExecutionResultEnum[c],
                        text: text,
                    };
                });
            return responseTypes;
        },
        selectedInstallationNames() {
            return this.filter.installationNames;
        },
    },
    watch: {
        deviceTreeSelectedObjectItems(newValue) {
            this.filter.installationNames = null;
            if (newValue) {
                if (newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).length > 0) {
                    this.ignoreSelectedInstallationNames = true;
                    this.filter.installationNames = newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).map((c) => c.id);
                }
            }
        },

        selectedInstallationNames(newValue) {
            if (!this.ignoreSelectedInstallationNames) {
                if (newValue && this.deviceTreeSelectedObjectItems != null) {
                    this.rerender += 1;
                    this.deviceTreeSelectedObjectItems = this.deviceTreeSelectedObjectItems.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device && newValue.indexOf(c.id) >= 0);
                }
            } else this.ignoreSelectedInstallationNames = false;
        },
    },
    methods: {},
});
